/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetOrderVolumeHistoryResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetOrderVolumeHistoryResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/order-volume/history
 */
export interface HistoryRequestBuilder extends BaseRequestBuilder<HistoryRequestBuilder> {
    /**
     * Returns what actually happened, month by month, as the actuals half of a history-and-forecast chart — pair it with GET /api/forecasting/order-volume for the projection. This reads recorded orders, so unlike the forecast endpoints it needs no trained model. The window ends at the present and runs back 'months' months, clamped to 1–60 and defaulting to 24; months with no orders are simply absent from the series rather than returned as zero, so a client drawing a chart should not assume evenly spaced points. An organisation with no orders in the window returns 404 rather than an empty series.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetOrderVolumeHistoryResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : Promise<GetOrderVolumeHistoryResponse | undefined>;
    /**
     * Returns what actually happened, month by month, as the actuals half of a history-and-forecast chart — pair it with GET /api/forecasting/order-volume for the projection. This reads recorded orders, so unlike the forecast endpoints it needs no trained model. The window ends at the present and runs back 'months' months, clamped to 1–60 and defaulting to 24; months with no orders are simply absent from the series rather than returned as zero, so a client drawing a chart should not assume evenly spaced points. An organisation with no orders in the window returns 404 rather than an empty series.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<HistoryRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns what actually happened, month by month, as the actuals half of a history-and-forecast chart — pair it with GET /api/forecasting/order-volume for the projection. This reads recorded orders, so unlike the forecast endpoints it needs no trained model. The window ends at the present and runs back 'months' months, clamped to 1–60 and defaulting to 24; months with no orders are simply absent from the series rather than returned as zero, so a client drawing a chart should not assume evenly spaced points. An organisation with no orders in the window returns 404 rather than an empty series.
 */
export interface HistoryRequestBuilderGetQueryParameters {
    /**
     * How many months of history to return (1 – 60). Defaults to 24.
     */
    months?: number;
}
/**
 * Uri template for the request builder.
 */
export const HistoryRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/order-volume/history?months={months}";
/**
 * Metadata for all the requests in the request builder.
 */
export const HistoryRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: HistoryRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetOrderVolumeHistoryResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
